<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="showTitle">List of Employee for Processing</span>
        <div class="flex-grow-1"></div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          @keyup="searchChange"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showDense">
          <v-row>
            <v-col>
              <v-checkbox label="Dense" v-model="dense"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>

        <v-data-table
          :items="filteredItems"
          :headers="headers"
          :loading="loading"
          :footer-props="footerProps"
          :dense="dense"
          item-key="empCode"
          :show-select="showSelect"
          text="Loading... Please wait"
          v-model="selected"
        >
          <template v-slot:header.data-table-select>
            <v-checkbox @change="toggleAll" color="default" v-model="selectAll" value />
            <!-- <v-checkbox
              @change="toggleAll"
              color="default"
              :indeterminate="props.indeterminate"
              value
              v-else
            />-->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// const API_ENDPOINT = "/api/payrollLocation";
import EventBus from "../../../events/eventBus";
export default {
  props: {
    showTitle: {
      default: true,
      type: Boolean
    },
    showDense: {
      default: true,
      type: Boolean
    },
    headers: {
      default: () => [
        {
          text: "",
          sortable: false,
          value: "actions"
        },
        {
          text: "Emp Code",
          align: "left",
          sortable: false,
          value: "empCode"
        },
        {
          text: "Employee Name",
          align: "left",
          sortable: false,
          value: "empName"
        },
        {
          text: "Tax Status",
          align: "left",
          sortable: false,
          value: "prevTaxCode"
        },
        {
          text: "New Tax Status",
          align: "left",
          sortable: false,
          value: "newTaxCode"
        }
      ],
      type: Array
    },
    showSelect: {
      default: false,
      type: Boolean
    },
    items: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    // items: [],
    search: "",
    footerProps: {
      rowsPerPageItems: [10, 25, 50, 100]
    },
    loading: false,
    dense: false,
    selected: [],
    selectAll: false
  }),
  computed: {
    filteredItems() {
      return this.filterItems(this.items, this.search);
    }
  },
  methods: {
    toggleAll() {
      if (this.selectAll) {
        if (this.search !== "") {
          this.selected = this.filteredItems;
        } else {
          this.selected = this.items.slice();
        }
      } else {
        if (this.selected.length) {
          this.selected = [];
        } else {
          if (this.search !== "") {
            this.selected = this.filteredItems;
            this.selectAll = true;
          } else {
            this.selected = this.items.slice();
          }
        }
      }
    },
    // getAll() {
    //   this.$axios
    //     .get(`${API_ENDPOINT}`)
    //     .then(({ data }) => {
    //       this.items = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     });
    // },
    selectedChanged(val) {
      EventBus.$emit("SELECTED_EMP_AUTOTAX", Object.assign([], val));
    },
    filterItems(items, query) {
      var filtered = items.filter(item => {
        let empCode = item.empCode.toString().includes(query.toLowerCase());
        let empName = item.empName.toLowerCase().includes(query.toLowerCase());

        return empCode || empName;
      });
      return filtered;
    },
    searchChange(e) {
      if (e.target.value === "") {
        this.selectAll = false;
        if (this.selected.length === this.items.length) this.selectAll = true;
        else this.selectAll = false;
      }
    }
  },
  created() {
    // this.getAll();
  },
  mounted() {
    // this.getAll();

    EventBus.$on("TOGGLE_SELECTED_EMP_AUTOTAX", payload => {
      this.selected = payload;
    });
  },
  watch: {
    selected(val) {
      this.selectedChanged(val);
      if (this.search !== "") {
        if (val.length !== this.filteredItems.length) this.selectAll = false;
        else this.selectAll = true;
      } else {
        if (val.length !== this.items.length) this.selectAll = false;
        else this.selectAll = true;
      }
    },
    search(val) {
      this.filterItems(this.items, val);
    }
  }
};
</script>